export default "__VITE_ASSET__But9T$fm__"